import * as React from "react"
import { Link } from "gatsby"
import {bgStyle,linkStyle,footerFontSize} from './footer.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWheelchair } from '@fortawesome/free-solid-svg-icons'
import {reRentCafeLink} from '../utils/helperFunctions'
import FloatingButton from './floatingContactButton' 



const Footer = ({cname,phone,email,address,slug,area,citySlug,hideFloatingContactButton=false,isMenuActive=false})=>{
    //console.log('is menu active in footer ',isMenuActive);
    const linkIt = area && slug && citySlug ? `/apartments/${area.toLowerCase()}/${citySlug.toLowerCase()}/${slug.toLowerCase()}/contact`: '/contact';
    const addr_array = address ? address.split(',') : ['NA','NA','NA','NA'];
    return(
        <section className={bgStyle+' '+footerFontSize}>
            <br />
            <br />
            <div className=" container">
                <div className="columns is-mobile is-multiline">
                    <div className="column ">
                        <h2 className="is-size-4 do-not-translate">{cname}</h2>
                        <p style={{marginBottom:'0'}}>
                            <img src="/imgs/whitemcklogo.png" alt="A McKinley Property" style={{maxWidth:'150px',position:'relative',left:'-5px',top:'-10px'}}/>
                        </p>
                        <p style={{position:'relative',top:'-10px',marginBottom:'0'}}>{phone}</p>
                        <p><a href={`mailto:${email}`} className="community-email-us-link">email us</a></p>
                        <p style={{marginBottom:'0'}}>{addr_array[0]}</p>
                        <p>{addr_array[1]}, {addr_array[2]} {addr_array[3]}</p>
                    </div>
                    <div className="column">
                        <p>
                        <Link to="/" className={`${linkStyle} community-footer-home-link`}>McKinley Corporate Page</Link>
                        </p>
                        <p>
                            <Link to="/career/" className={`${linkStyle} community-footer-careers`}>McKinley Careers</Link>
                        </p>
                        <p>
                            <Link to="/apartments/michigan/ann-arbor/" className={`${linkStyle} community-footer-annarbor`}>Ann Arbor Apartments</Link>
                        </p>
                        <p>
                            <Link to="/apartments/florida/orlando/" className={`${linkStyle} community-footer-orlando`}>Orlando Apartments</Link>
                        </p>
                    </div>
                    <div className="column">
                        <p>
                        <a href={reRentCafeLink(slug)} target="_blank" className={`${linkStyle} community-footer-resident-login`}>Resident Login</a>

                        </p>
                        <p>
                        <Link to="/blog" className={`${linkStyle} community-footer-blog`}>McKinley Living Blog</Link>
                        </p>
                        <p>
                        <Link to="/cares" className={`${linkStyle} community-footer-blog`}>McKinley Cares</Link>
                        </p>
                        <p>
                            <a href="https://www.facebook.com/MckinleyCompaniesLLC" target="_blank"><img src="/imgs/facebook.png" alt="facebook"/></a>&nbsp;&nbsp;&nbsp;
                            <a href="https://www.instagram.com/mckinley.living/?igsh=OHhkYm1zemJpMTNw&utm_source=qr" target="_blank"><img src="/imgs/instagram.png" alt="instagram"/></a>&nbsp;&nbsp;&nbsp;
                            <a href="https://www.linkedin.com/company/mckinley/mycompany/?viewAsMember=true" target="_blank"><img src="/imgs/linkedin.png" alt="linked in"/></a>
                        </p>
                    </div>
                    <div className="column">
                        <p>
                        <Link to="/policy/" className={`${linkStyle} community-footer-privacy-policy`}>Privacy Policy</Link>
                        </p>
                        <p>
                        <Link to="/contact/" className={`${linkStyle} community-footer-contact-us`}>Contact Us</Link>
                        </p>
                    </div>
                </div>
                <div className="columns is-mobile is-multiline">
                    <div className="column is-full-mobile do-not-translate">
                        &copy; 2022 - 2025 McKinley Companies LLC
                    </div>
                    <div className="column has-text-right ">
                        Equal Housing Opportunity Provider
                        <svg className="mb-2" width="21" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.48 12.64" style={{position:'relative',left:'10px',top:'10px'}}><title>HUD Logo</title><path d="M11.78,11.16H1.67V4.72l5.06-3,5.06,3ZM6.74,0,0,4.05v8.58H13.48V4.05ZM4,9.5H9.51V7.76H4ZM4,7.26H9.51V5.52H4Z" style={{fill:'#ffffff'}}></path></svg>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <FontAwesomeIcon icon={ faWheelchair } style={{fontSize:'20px'}}  />
                    </div>
                </div>
            </div>
            <br />
            <br />
            {!hideFloatingContactButton && !isMenuActive && 
                <FloatingButton linkIt={linkIt}/>
            }
        </section>
    )
}


export default Footer 
